import { useIntl } from "react-intl"

import dayjs from "dayjs"

import { StaffBodyTextXXS, StaffHeading4, StaffLabelTextXS } from "@doktor-se/bones-ui"

import { useAppSelector } from "lib/hooks"

import SlotHistoryEventDetails from "../slot/history/SlotHistoryEventDetails"
import { findRole } from "./StaffRoles"

import styles from "./History.module.scss"

export interface HistoryEvent {
  createdAt: Date
  id: string
  eventType: string
  data: { [key: string]: any }
}

interface HistoryProps {
  heading?: string
  history: HistoryEvent[]
  eventTypeMap: Record<string, string>
}

const History = ({ heading, history, eventTypeMap }: HistoryProps) => {
  const intl = useIntl()
  const allStaff = useAppSelector(state => state.users.staff)

  const staffDisplayName = (staffId: string) => {
    const staff = allStaff.find(staff => staff.id === staffId)
    const staffRole = intl.formatMessage({ id: `label.role.${getStaffRole(staffId)}` })
    return `${staff?.displayName} (${staffRole})`
  }

  const getStaffRole = (staffId?: string) => findRole(allStaff.find(staff => staff.id === staffId))

  return (
    <>
      {heading && <StaffHeading4>{heading}</StaffHeading4>}
      {history && history.length ? (
        <>
          {history?.map((event, idx) => (
            <div key={idx} className={styles.event}>
              <div className={styles.timeline}>
                <div className={styles.circle} />
                <div className={styles.line} />
              </div>

              <div className={styles.content}>
                <StaffLabelTextXS>{eventTypeMap[event.eventType]}</StaffLabelTextXS>
                <div>
                  <StaffBodyTextXXS>
                    {`${intl.formatMessage({ id: "booking.history.by.prefix" })} 
                    ${
                      event.eventType.endsWith("_by_patient")
                        ? intl.formatMessage({ id: "booking.history.event.patient" })
                        : staffDisplayName(event.data.actingUserId)
                    }`}
                  </StaffBodyTextXXS>
                </div>
                <div>
                  <StaffBodyTextXXS>{dayjs(event.createdAt).format("YYYY-MM-DD HH:mm")}</StaffBodyTextXXS>
                </div>
                <SlotHistoryEventDetails eventData={event.data} />
              </div>
            </div>
          ))}
        </>
      ) : (
        <StaffBodyTextXXS>{intl.formatMessage({ id: "booking.history.event.empty" })}</StaffBodyTextXXS>
      )}
    </>
  )
}

export default History
